import axios, { type InternalAxiosRequestConfig } from 'axios'
import {
  buildWarehouseScopedStorageKey,
  getCustomerApiBaseUrl,
  getCurrentApiBaseUrl,
  resolveCustomerApiPath,
  resolveCustomerApiUrl,
  resolveApiPath,
  resolveApiUrl,
} from '@/features/warehouse/config'

export const API_BASE_URL = getCurrentApiBaseUrl()
const AUTH_TOKEN_KEY = 'nurm_token_v1'

export const getStoredToken = (): string | null =>
  localStorage.getItem(buildWarehouseScopedStorageKey(AUTH_TOKEN_KEY))

export const getStoredTokenForWarehouse = (warehouseId: string): string | null =>
  localStorage.getItem(buildWarehouseScopedStorageKey(AUTH_TOKEN_KEY, warehouseId))

export const setStoredToken = (token: string | null) => {
  const storageKey = buildWarehouseScopedStorageKey(AUTH_TOKEN_KEY)
  if (token) localStorage.setItem(storageKey, token)
  else localStorage.removeItem(storageKey)
}

export const apiClient = axios.create({
  baseURL: getCurrentApiBaseUrl(),
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const customerApiClient = axios.create({
  baseURL: getCustomerApiBaseUrl(),
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const withToken = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const token = getStoredToken()
  if (token) {
    config.headers.Authorization = `Token ${token}`
  }
  return config
}

apiClient.interceptors.request.use((config) => {
  config.baseURL = getCurrentApiBaseUrl()
  if (typeof config.url === 'string') {
    config.url = resolveApiPath(config.url)
  }
  return withToken(config)
}, (error) => Promise.reject(error))

customerApiClient.interceptors.request.use((config) => {
  config.baseURL = getCustomerApiBaseUrl()
  if (typeof config.url === 'string') {
    config.url = resolveCustomerApiPath(config.url)
  }
  return withToken(config)
}, (error) => Promise.reject(error))

apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
)

customerApiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
)

export const buildApiUrl = (path: string): string => resolveApiUrl(path)
export const buildCustomerApiUrl = (path: string): string => resolveCustomerApiUrl(path)

export default apiClient
